
<template>
  <div class="addAppVersion">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump()">{{$t('lang.btn_backApp')}}</el-button>
      </div>
      <el-form :rules="rules" ref="form" :model="form" class="form_show" :label-width="require('@/config/enum').c_ws8" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_appAreaValue')" prop="appAreaValue">
          <el-select class="select" v-model="form.appAreaValue" placeholder>
            <el-option
              v-for="item in appArea"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_mobile')" v-if="form.appAreaValue === '1'" prop="appAreaValues" ref="appAreaValues">
         <upload-file ref="uploading" :accept='accept' :fileList='form.fileList' :clears='clears'  @outputFile="getFile" @removeFile='removeFile' upTypes='2'></upload-file>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_uri')" prop="uri" v-if="form.appAreaValue === '2'">
          <el-input v-model="form.uri" :placeholder="$t('lang.lab_uri')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_versionCode')" prop="versionCode">
          <el-input v-model="form.versionCode" :placeholder="$t('lang.lab_versionCode')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_appId')" prop="appId">
          <el-select class="select" v-model="form.appId" placeholder>
            <el-option
              v-for="item in appType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_upgradeLevel')" prop="upgradeLevel">
          <el-select class="select" v-model="form.upgradeLevel" placeholder>
            <el-option
              v-for="item in appUpdate"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.key_versionName')" prop="versionName">
          <el-input v-model="form.versionName" :placeholder="$t('lang.key_versionName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.key_title')" prop="title">
          <el-input v-model="form.title" :placeholder="$t('lang.key_title')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.key_content')" prop="content">
          <el-input v-model="form.content" :placeholder="$t('lang.key_content')"></el-input>
        </el-form-item>
        <el-form-item label="详情链接" prop="detailUri">
          <el-input v-model="form.detailUri" placeholder="详情链接"></el-input>
        </el-form-item>
          <el-button @click="rest('form')" class="btn-first">{{$t('lang.btn_rest')}}</el-button>
          <el-button
            type="primary"
            class="detailbtn"
            @click="onSubmit('form')"
          >{{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>
<script>
/**
 *@ClassName:addAppVersion
 *@Description:添加APP版本
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-16
 */
import UploadFile from '../../../components/upload_file.vue'
export default {
  data() {
    // eslint-disable-next-line
    var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
    var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$i18n.t('lang.lab_pleInputLink')))
        } else {
          if (!reg.test(value)) {
            callback(new Error(this.$i18n.t('lang.lab_pleInputRLink')))
          }
          callback()
        }
    }
    var positiveInteger = /^[0-9]*[1-9][0-9]*$/
    var positiveIntegerChenk = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$i18n.t('lang.lab_inputpositiveInteger')))
        } else {
          if (!positiveInteger.test(value)) {
            callback(new Error(this.$i18n.t('lang.lab_inputpositiveInteger')))
          }
          callback()
        }
    }
    var appValueWatch = (rule, value, callback) => {
        if (value === '0') {
          callback(new Error(this.$i18n.t('lang.key_appplatform')))
        } else {
          callback()
        }
    }
    var appIdValue = (rule, value, callback) => {
        if (value === '0') {
          callback(new Error(this.$i18n.t('lang.key_apptype')))
        } else {
          callback()
        }
    }
    var upgradeLevelValue = (rule, value, callback) => {
        if (value === '0') {
          callback(new Error(this.$i18n.t('lang.key_appupdate')))
        } else {
          callback()
        }
    }
    return {
      accept: '.jpg,.jpeg,.png,.apk,.apk.1',
      clears: false, // 清空按钮
      form: {
        appAreaValues: '',
        mobile: '',
        uri: '',
        versionCode: '',
        appId: '0',
        appAreaValue: '0',
        upgradeLevel: '0',
        versionName: '',
        title: '',
        content: '',
        detailUri: '',
        fileList: [],
      }, // 对象
      rules: {
        uri: [{ required: true, validator: validatePass, trigger: 'blur' }],
        versionCode: [
          { required: true, validator: positiveIntegerChenk, trigger: 'blur' },
          { max: 8, message: this.$i18n.t('lang.lab_inputAPPVersionCodeEight'), trigger: 'blur' }
        ],
        appId: [{ required: true, validator: appIdValue, trigger: 'change' }],
        appAreaValue: [{ required: true, validator: appValueWatch, trigger: 'change' }],
        appAreaValues: [{ required: true, message: this.$i18n.t('lang.key_up_file'), trigger: 'change' }],
        upgradeLevel: [{ required: true, validator: upgradeLevelValue, trigger: 'change' }],
        versionName: [
          { required: true, message: this.$i18n.t('lang.key_versionname'), trigger: 'blur' },
          { max: 10, message: this.$i18n.t('lang.key_versionNameIsTen'), trigger: 'blur' }
        ],
        title: [{ required: true, message: this.$i18n.t('lang.key_uptitle'), trigger: 'blur' }],
        content: [{ required: true, message: this.$i18n.t('lang.key_upcontent'), trigger: 'blur' }]
      }, // 表单验证
      appType: this.$i18n.t('lang.appVersionManagement.appType'), // 下拉列表
      appUpdate: this.$i18n.t('lang.appVersionManagement.appUpdate'), // 下拉列表
      appArea: this.$i18n.t('lang.appVersionManagement.appArea') // 下拉列表
    }
  },
  components: {
		'upload-file': UploadFile
  },
   destroyed() {
    window.localStorage.setItem('appbbform', JSON.stringify(this.form))
  },
  created() {
    if (window.localStorage.getItem('appbbform')) {
      this.form = JSON.parse(window.localStorage.getItem('appbbform'))
      if (this.form.appAreaValues) {
         this.form.fileList.push({
            name: '',
            url: this.form.appAreaValues
          })
      }
    }
  },
  methods: {
     // 获取组件值
    getFile(e) {
      this.form.appAreaValues = e
      this.$refs.appAreaValues.clearValidate()
    },
    // 移除图片
    removeFile(e) {
      this.form.fileList = []
      this.form.appAreaValues = ''
    },
  // 清空表单
    rest(form) {
      this.form.fileList = []
      this.clears = true
      this.$refs.form.resetFields()
      this.form.appAreaValues = ''
      this.form.mobile = ''
      this.form.uri = ''
      this.form.versionCode = ''
      this.form.appId = '0'
      this.form.appAreaValue = '0'
      this.form.upgradeLevel = '0'
      this.form.versionName = ''
      this.form.title = ''
      this.form.content = ''
      this.form.detailUri = ''
     },
   onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.appAreaValue === '1') {
            this.form.uri = this.form.appAreaValues
          }
          let parse = {
            versionCode: this.form.versionCode,
            appId: this.form.appId,
            platform: this.form.appAreaValue,
            upgradeLevel: this.form.upgradeLevel,
            versionName: this.form.versionName,
            title: this.form.title,
            content: this.form.content,
            detailUri: this.form.detailUri,
            imgUri: this.form.uri
          }
          let loading = this.$loading()
          // POST接口不好使时，用如下方式进行请求
          this.$post(`/version/upload`, parse).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.$router.push({ name: 'APPVersion' })
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      })
    },
    jump() {
      this.$router.push({ name: 'APPVersion' })
    },
  }
}
</script>

<style lang="scss">
.addAppVersion .form {
  text-align: left;
}
.addAppVersion .select {
  width: 100%;
}
.addAppVersion .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.addAppVersion .el-form-item__content {
  width: 60vw !important;
}
.addAppVersion.el-main {
  padding: 0px;
}
</style>